export default __webpack_public_path__ + "static/media/add.4e51d0a0.svg";